import {Toast} from "antd-mobile";

const bottomToast = (content, position, callBack) => {
    Toast.show({
        content: content,
        position: position ? position: 'bottom',
        onClose: callBack ?  callBack() : null,
    })
}

export {bottomToast}